import React from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import PremiumIcon from '../../../Icons/Premium';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarLink from '../../_partials/items/ActionBarLink';
var EditPcpLink = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    return (React.createElement(ActionBarItemWrapper, { tooltip: t('actionbar.pcp.owned') },
        React.createElement(ActionBarLink, { href: get(deviation, 'extended.editUrl') },
            React.createElement(ActionBarIcon, { icon: PremiumIcon }))));
};
EditPcpLink.displayName = 'EditPcpLink';
export default EditPcpLink;
//# sourceMappingURL=EditPcpLink.js.map